import { Spin } from 'antd';
import React, { Suspense, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import Investments from './investments';
import InvestorDashboard from './dashboard';
import Profile from './profile';
import Projects from './projects';
import Validations from './validations';
import Wallet from './wallet';
import Documents from './documents';
import withAdminLayout from '../../layout/withAdminLayout';
import InvestorStripeConnect from '../../components/stripe/InvestorStripeConnect';
// import InvestPaymentPage from '../../components/stripe/InvestorInvest';
import StripeReauthPage from '../../components/stripe/StripeReauthPage';
import StripeSuccessPage from '../../components/stripe/StripeSuccessPage';
import PaymentSuccessPage from '../../components/pesapal/PaymentSuccessPage';
import ManualInvestPaymentPage from '../../components/stripe/manualInvest';

const Investor = React.memo(() => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Suspense
      fallback={
        <div className="spin">
          <Spin />
        </div>
      }
    >
      <Routes>
        <Route index path="/*" element={<InvestorDashboard />} />
        <Route path="pages/*" element={<InvestorDashboard />} />
        <Route path="wallet/*" element={<Wallet />} />
        <Route path="profile/*" element={<Profile />} />
        <Route path="projects/*" element={<Projects />} />
        <Route path="validation/*" element={<Validations />} />
        <Route path="investments/*" element={<Investments />} />
        <Route path="documents/*" element={<Documents />} />
        <Route path="connect" element={<InvestorStripeConnect />} />
        <Route path="reauth" element={<StripeReauthPage />} />
        <Route path="payment/success" element={<PaymentSuccessPage />} />
        <Route path="success" element={<StripeSuccessPage />} />
        <Route path="investment/payment/:id" element={<ManualInvestPaymentPage />} />
      </Routes>
    </Suspense>
  );
});

export default withAdminLayout(Investor);
